import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';

export default class VideoContent extends Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    event.preventDefault();
    if(window.vexpo && window.vexpo.overlay)
      window.vexpo.overlay(this.props);
  }
  /** @function
   * Renders the Video Content component.
   */
  render() {
    if(this.props.thumbnail !== undefined) {
      const style = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textShadow: '-1px -1px 0 #ccc, 1px -1px 0 #ccc, -1px 1px 0 #ccc, 1px 1px 0 #ccc'
      }
      return (
        <div onClick={this.handleClick} style={{cursor: 'pointer'}}>
          <img src={this.props.thumbnail} alt={this.props.name}/>
          <FontAwesome name="play" size="4x" style={style} />
        </div>
      );
    } else {
      return (
        <div onClick={this.handleClick} style={{textAlign: 'center', cursor: 'pointer'}}>
          <FontAwesome name="play-circle" size="4x" /><br />
          {this.props.name}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/content/video-content.js